export default "__VITE_ASSET__Bg9xf06K__"